export default __webpack_public_path__ + "static/majestic-ireland-homepage-loop-hd-7f056225fba16b16553033989e0c066f.webm";